import React from 'react'



import Todo from "./component/todo";


const App = () => {
  return <Todo/>;
}

export default App
